<template>
  <div class="media media-comment px-1">
    <!-- <img alt="User" class="avatar avatar-md media-comment-avatar rounded-circle" :src="comment.userInfo.userPictureUrl"> -->
    <div class="b-avatar-circle"><user-image :user="comment.userInfo"></user-image></div>
    <!-- <b-avatar variant="primary" text="BV" class="text-center"></b-avatar> -->
    <div class="media-body">
      <div class="media-comment-text m-1">
        <h5 class="mt-0">{{name}}</h5>
        <p class="text-sm lh-160" v-html="comment.text"></p>
        <!-- <div class="icon-actions">
          <a href="#" class="like active">
            <i class="ni ni-like-2"></i>
            <span class="text-muted">{{likeCount}} likes</span>
          </a>
          <a href="#">
            <i class="ni ni-curved-next"></i>
            <span class="text-muted">{{shareCount}} shares</span>
          </a>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import UserImage from './User/UserImage.vue';

export default {
  components: { UserImage },
  name: 'comment',
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    name() {
      if (!this.comment.userInfo || this.comment.userInfo.userNickname === '' || (this.comment.userInfo.userFirstName === '' && this.comment.userInfo.userLastName === '')) {
        return 'Unknown User';
      }
      const name = this.comment.userInfo.userNickname ? this.comment.userInfo.userNickname : `${this.comment.userInfo.userFirstName} ${this.comment.userInfo.userLastName}`;
      const maxLength = 32;
      if (name.length <= maxLength) {
        return name;
      }
      // Return str truncated with '...' concatenated to the end of str.
      return `${name.slice(0, maxLength)}...`;
    },
  },
};
</script>
<style>
.b-avatar-circle {
  margin-top: -1rem;
  margin-right: -2rem;
  position: relative;
  z-index: 1;
}
</style>
